import { makeStyles } from '@material-ui/core/styles'

// Page layout, cards, rows, and headings come from the coach Settings styles;
// these are only the pieces the Settings page does not have.
const useStyles = makeStyles(theme => ({
  studentName: {
    display: 'inline-block',
    color: '#172024',
    textDecoration: 'none',
    '&:hover, &:focus-visible': {
      color: '#0053FF',
    },
  },
  attentionRow: {
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
    [theme.breakpoints.down('xs')]: {
      flexWrap: 'wrap',
    },
  },
  lastLesson: {
    flexShrink: 0,
    minWidth: 160,
    [theme.breakpoints.down('xs')]: {
      order: 3,
      flexBasis: '100%',
      paddingLeft: 48,
    },
  },
  followUpButton: {
    flexShrink: 0,
    borderRadius: 100,
  },
  sentenceCaseLabel: {
    '&&': {
      textTransform: 'none',
    },
  },
}))

export default useStyles
